module.exports = __webpack_public_path__ + "media/images/demo_tests/shapeshift-069d0b55297feac186ce5106b7d53339.png";